export const VISIT_PLAN_AUDIT_LOG_TABLE_UNIQUE_ID = 'visit-plan-audit-log';

export const VISIT_PLAN_AUDIT_LOG_ROW_HEIGHT = 48;

export const DEFAULT_VISIT_PLAN_AUDIT_LOG_COLUMN_WIDTHS: { [key: string]: number } = {
  'col-timestamp': 170,
  'col-by': 170,
  'col-action': 425,
  'col-agent': 255,
  'col-account': 255,
  'col-for-days': 170,
  'col-current-state': 255
};
